export const SDK_VERSION = '7.41.0';
